export default __webpack_public_path__ + "static/media/COPNIA.9cfa561f.png";